import React from 'react';
import TableLink from "v4/components/utils/TableLink/TableLink";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import useListingRowActionsRoute from "v4/hooks/useListingRowActionsRoute";

export default function ContactsListingRowActions({ rowId, prospectId }) {
    const route = useListingRowActionsRoute([
        { identifier: 'detail_contacts', condition: true }
    ]);

    return (
        <TableLink href={`/${resolveUrl(route.url, { prospect: prospectId })}/${rowId}`}/>
    )
}
